import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchTenantBilling } from "../../../store/authSlice";
import { isClubStaff } from "../../../utils/roles";
import { TRIAL_DAYS } from "../../../constants/trial";
import aa from "./adminApp.module.css";

function formatRub(n) {
  return new Intl.NumberFormat("ru-RU").format(Number(n) || 0);
}

function SubscriptionExpiredScreen({ billing }) {
  const isDemoExpired = Boolean(billing?.is_demo_expired);
  const price = billing?.payment_amount_rub ?? billing?.monthly_price_rub;

  return (
    <div className={aa.subscriptionGate} role="dialog" aria-modal="true">
      <div className={aa.subscriptionGateCard}>
        <span className={aa.subscriptionGateEyebrow}>
          {isDemoExpired ? "Демо-доступ закончился" : "Подписка не активна"}
        </span>
        <h2 className={aa.subscriptionGateTitle}>
          Оплатите подписку, чтобы продолжить работу
        </h2>
        <p className={aa.subscriptionGateText}>
          {isDemoExpired
            ? `Бесплатный период ${TRIAL_DAYS} дней завершён. Для доступа к журналу, клиентам, финансам и аналитике оформите подписку CRM.`
            : "Без активной подписки функции клуба недоступны. Оформите подписку, чтобы вернуть полный доступ."}
        </p>
        {price ? (
          <p className={aa.subscriptionGatePrice}>
            Тариф «{billing?.plan_label || "Старт"}» —{" "}
            <strong>{formatRub(price)} ₽</strong>
            {billing?.billing_period_label
              ? ` / ${billing.billing_period_label}`
              : " / мес"}
          </p>
        ) : null}
        <div className={aa.subscriptionGateActions}>
          <Link to="/manage/app/profile" className={aa.subscriptionGateBtnPrimary}>
            Подписка и оплата
          </Link>
          <a href="mailto:support@bay-sport.ru" className={aa.subscriptionGateBtnGhost}>
            Написать в поддержку
          </a>
        </div>
      </div>
    </div>
  );
}

export default function SubscriptionGate({ children }) {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { isAuth, role, billing, billingLoad } = useSelector((state) => state.auth);
  const isStaff = isAuth && isClubStaff(role);
  const onProfile =
    pathname === "/manage/app/profile" || pathname.endsWith("/profile");

  useEffect(() => {
    if (isStaff) {
      dispatch(fetchTenantBilling());
    }
  }, [isStaff, dispatch]);

  if (!isStaff || billingLoad || billing == null || billing.is_paid) {
    return children;
  }

  if (onProfile) {
    return children;
  }

  return (
    <>
      <div className={aa.subscriptionGateBackdrop} aria-hidden>
        {children}
      </div>
      <SubscriptionExpiredScreen billing={billing} />
    </>
  );
}
